@if(this.ficha$ | async; as ficha){
    <div class="flex flex-col gap-4 w-full">
        <div class="flex-1 flex flex-col text-xs md:text-sm">
            <label class="flex items-center py-1 text-xs md:text-md font-semibold"
                >Descripción*</label>
            <textarea
            [(ngModel)]="detalle.descripcion"
            name="descripcion" 
            id="descripcion" 
            rows="3" 
            class="flex-1 p-2 border-2 text-sm md:text-md leading-normal" 
            placeholder="Descripción"></textarea>
        </div>

        <div class="flex-1 flex flex-col text-xs md:text-sm">
            <label class="flex items-center py-1 text-xs md:text-md font-semibold"
                >Observaciones*</label>
            <textarea
            [(ngModel)]="detalle.observaciones"
            name="observaciones" 
            id="observaciones" 
            rows="3" 
            class="flex-1 p-2 border-2 text-sm md:text-md leading-normal"></textarea>
        </div>

        <div class="flex-1 flex flex-col text-xs md:text-sm">
            <label class="flex items-center py-1 text-xs md:text-md font-semibold"
                >Anotaciones*</label>
            <textarea
            [(ngModel)]="detalle.anotaciones"
            name="anotaciones" 
            id="anotaciones" 
            rows="3" 
            class="flex-1 p-2 border-2 text-sm md:text-md leading-normal"></textarea>
        </div>

        <div class="flex-1 flex flex-col text-xs md:text-sm">
            <label class="flex items-center py-1 text-xs md:text-md font-semibold"
                >Decreto / Acuerdo*</label>
            <textarea
            [(ngModel)]="detalle.decretoAcuerdo"
            name="decretoAcuerdo" 
            id="decretoAcuerdo" 
            rows="3" 
            class="flex-1 p-2 border-2 text-sm md:text-md leading-normal"></textarea>
        </div>

        <div class="mt-8 flex justify-start w-full ml-0 md:ml-0.5">
            <button mat-raised-button
                class="w-full md:w-40 rounded-md font-bold h-12" 
                (click)="putDetalleBienCultural(ficha.bienCultural.bienCulturalUuid)">
                Guardar
            </button>
        </div>
    </div>
}